const hideTaxId = (texId)  =>  texId.split('').map((item,index) => index >= 3 &&  index < 10 ? "*" :item  ).join('');

export default hideTaxId;